// This is public bucket available to all internet for view
// https://cloud.google.com/storage/docs/uniform-bucket-level-access
// https://cloud.google.com/storage/docs/cloud-console#_publicaccess

const PUBLIC_BUCKET_NAME = 'static-event-maker-prod';

export const getStorageUrl = (path: string) => {
  return `https://storage.googleapis.com/${PUBLIC_BUCKET_NAME}/${path}`;
};
